import React, { useState, useContext } from 'react';
import { Layout, Space } from 'antd';
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import { useLocation } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthContext';
import SuperAdminSidebar from '../sidebar/SuperAdminSidebar';
import ClientSidebar from '../sidebar/ClientSidebar';
import AgencySidebar from '../sidebar/AgencySidebar';
import WhiteLabelAgencySidebar from '../sidebar/WhiteLabelAgencySidebar';
import ThemeToggle from '../common/ThemeToggle';

const { Header, Content } = Layout;

const DashboardLayout = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);
  const { currentUser, logout } = useContext(AuthContext);
  const location = useLocation();
  const isMcp = location.pathname.startsWith('/client/mcp');

  // Toggle sidebar collapse
  const toggleCollapse = () => {
    setCollapsed(!collapsed);
  };

  // Get the appropriate sidebar based on user role
  const renderSidebar = () => {
    if (!currentUser) return null;

    const commonProps = {
      collapsed,
      onCollapse: toggleCollapse,
    };

    switch (currentUser.role) {
      case 'superadmin':
        return <SuperAdminSidebar {...commonProps} />;
      case 'client':
        return <ClientSidebar {...commonProps} />;
      case 'agency':
        return <AgencySidebar {...commonProps} />;
      case 'whitelabel_agency':
        return <WhiteLabelAgencySidebar {...commonProps} />;
      default:
        return null;
    }
  };

  return (
    <Layout style={{ minHeight: '100vh' }}>
      {renderSidebar()}
      <Layout className="site-layout" style={{ 
        marginLeft: collapsed ? '80px' : '250px', 
        transition: 'var(--transition, all 0.3s ease)',
        width: 'calc(100% - 250px)',
        maxWidth: '100%',
        position: 'relative',
        background: isMcp ? 'var(--paper, #FBF7F0)' : 'var(--white, #ffffff)',
        minHeight: '100vh'
      }}>
        {!isMcp && (
          <Header style={{
            padding: '0 24px',
            background: 'var(--white, #ffffff)',
            boxShadow: '0 2px 8px rgba(42, 118, 232, 0.1)',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            position: 'fixed',
            zIndex: 1,
            width: '100%',
            left: collapsed ? '80px' : '270px',
            right: 0,
            paddingRight: '24px'
          }}>
            <div>
              {collapsed ? (
                <MenuUnfoldOutlined
                  className="trigger"
                  onClick={toggleCollapse}
                  style={{ padding: '0 24px', fontSize: '18px', lineHeight: '64px', cursor: 'pointer' }}
              />
              ) : (
                <MenuFoldOutlined
                  className="trigger"
                  onClick={toggleCollapse}
                  style={{ padding: '0 24px', fontSize: '18px', lineHeight: '64px', cursor: 'pointer' }}
                />
              )}
            </div>
            <div>
              <Space size="middle" align="center">
                <ThemeToggle />
                <span style={{ marginRight: '8px' }}>
                  {currentUser?.full_name || currentUser?.email}
                </span>
                <button 
                  onClick={logout} 
                  style={{ 
                    background: 'none',
                    border: 'none',
                    color: '#1890ff', 
                    cursor: 'pointer',
                    padding: 0,
                    font: 'inherit',
                    textDecoration: 'underline',
                    textAlign: 'left'
                  }}
                >
                  Logout
                </button>
              </Space>
            </div>
          </Header>
        )}
        <Content
          className="site-layout-background"
          style={{
            margin: isMcp ? 0 : '88px 16px 24px 16px',
            padding: isMcp ? 0 : '24px',
            minHeight: 'calc(100vh - 112px)',
            background: isMcp ? 'transparent' : 'var(--white, #ffffff)',
            borderRadius: isMcp ? 0 : 'var(--card-radius, 12px)',
            boxShadow: isMcp ? 'none' : 'var(--shadow, 0 10px 30px rgba(42, 118, 232, 0.15))',
            maxWidth: '100%',
            width: 'auto',
            overflow: 'initial',
            marginLeft: isMcp ? 0 : '16px',
            marginRight: isMcp ? 0 : '16px',
            transition: 'var(--transition, all 0.3s ease)'
          }}
        >
          {children}
        </Content>
      </Layout>
    </Layout>
  );
}

export default DashboardLayout;
